export class PsContractor {

    _id; // number
    _nif; // string
    _name; // string
    _active; // boolean
    _ccc; // string
    _contactPerson; // string
    _email; // string
    _phone; // string
    _address; // string

    constructor(
        id,
        nif,
        name,
        active,
        ccc,
        contactPerson,
        email,
        phone,
        address
    ) {
        this._id = id;
        this._nif = nif;
        this._name = name;
        this._active = active;
        this._ccc = ccc;
        this._contactPerson = contactPerson;
        this._email = email;
        this._phone = phone;
        this._address = address;
    }

    static fromAPIContractors(contractors) {
        return contractors.map((ct) => PsContractor.fromAPIContractor(ct));
    }

    static fromAPIContractor(contractor) {
        return new this(
            contractor.id,
            contractor.nif,
            contractor.name,
            !contractor.disabled,
            contractor.ccc,
            contractor.contact_person,
            contractor.email,
            contractor.phone,
            contractor.address
        );
    }

    id() {
        return this._id;
    }

    nif() {
        return this._nif;
    }

    name() {
        return this._name;
    }

    isActive() {
        return this._active;
    }

    ccc() {
        return this._ccc;
    }

    contactPerson() {
        return this._contactPerson;
    }

    email() {
        return this._email;
    }

    phone() {
        return this._phone;
    }

    address() {
        return this._address;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/PsContractor.js